import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { VehicleProvider } from "@/context/VehicleContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ConfirmEmail from "@/pages/ConfirmEmail";
import Console from "@/pages/Console";
import Garage from "@/pages/Garage";
import RegisterVehicle from "@/pages/RegisterVehicle";
import VehicleDashboard from "@/pages/VehicleDashboard";
import Marketplace from "@/pages/Marketplace";
import SalesDesk from "@/pages/SalesDesk";
import AdminPlatform from "@/pages/AdminPlatform";
import { StaffRoute } from "@/components/StaffRoute";
import { AdminRoute } from "@/components/AdminRoute";

function CatalogBridge() {
  const { wd_id } = useParams();
  return <Navigate to={`/console/register?wd_id=${wd_id}`} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <VehicleProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/confirm" element={<ConfirmEmail />} />
              <Route
                path="/console"
                element={
                  <ProtectedRoute>
                    <Console />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/console/register"
                element={
                  <ProtectedRoute>
                    <RegisterVehicle />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/console/garage"
                element={
                  <ProtectedRoute>
                    <Garage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/console/marketplace"
                element={
                  <ProtectedRoute>
                    <Marketplace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/console/sales"
                element={
                  <StaffRoute>
                    <SalesDesk />
                  </StaffRoute>
                }
              />
              <Route
                path="/console/admin"
                element={
                  <AdminRoute>
                    <AdminPlatform />
                  </AdminRoute>
                }
              />
              <Route
                path="/console/vehicle/:id"
                element={
                  <ProtectedRoute>
                    <VehicleDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/console/car/:wd_id"
                element={
                  <ProtectedRoute>
                    <CatalogBridge />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </VehicleProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
